import React, { FC } from 'react';
import { View } from 'react-native';
import OperatorPanelSettingsWrapper from './OperatorPanelSettingsWrapper';
import { navigateTo } from '@helpers';
import ColorWrapper from '@styles/colors';
import { ColorFunction } from '@styles/colors/types';
import { connect } from 'react-redux';
import { Machine } from '@interfaces/machines';
import { MachineList } from '@v2/pages/common/modals/ncFile/SendingToMachineSelectMachineStep';
import { scaleOP } from '@components/frame';
import { setSelectedMachine } from '@reducers/machines';
import { fontOP } from '@styles/fonts';

interface OperatorPanelSettingsMachineSelectProps {
  C: ColorFunction;
  machines: Machine[];
  setSelectedMachine: (machine: Machine) => void;
}

const OperatorPanelSettingsMachineSelect: FC<OperatorPanelSettingsMachineSelectProps> = ({ C, machines, setSelectedMachine }) => {
  const onSelectMachine = (machine: Machine) => {
    setSelectedMachine(machine);
    navigateTo('OperatorPanel', { id: machine.machineId });
  };

  return (
    <OperatorPanelSettingsWrapper.Root C={C} containerStyles={{ justifyContent: 'flex-start' }} scale={scaleOP} font={fontOP}>
      <OperatorPanelSettingsWrapper.Header>
        <OperatorPanelSettingsWrapper.Title text="Select Machine" />
        <OperatorPanelSettingsWrapper.HeaderRightSide>
          <OperatorPanelSettingsWrapper.CloseButton />
        </OperatorPanelSettingsWrapper.HeaderRightSide>
      </OperatorPanelSettingsWrapper.Header>

      <OperatorPanelSettingsWrapper.Content>
        <View style={{ marginTop: scaleOP(74), alignItems: 'center', width: scaleOP(450), flex: 1, }}>
          <MachineList machines={machines} C={C} onSelect={onSelectMachine} containerStyles={{ width: '100%' }} scale={scaleOP} font={fontOP} />
        </View>
      </OperatorPanelSettingsWrapper.Content>
    </OperatorPanelSettingsWrapper.Root>
  );
};

export default connect(({ machines: { machines } }) => ({ machines }), { setSelectedMachine })(ColorWrapper(OperatorPanelSettingsMachineSelect));
